import { Injectable } from '@angular/core';
import { DeviceProvider } from '../device/device';
import { Events, ToastController } from 'ionic-angular';
import { DomainEvents } from '../../models/models';

/**

Responsabile della comunicazione con altre App sullo stesso dispositivo

*/
@Injectable()
export class InterappProvider {

	constructor(
		private devices: DeviceProvider,
		private events: Events,
		private toastCtrl: ToastController,
	) {
		let self = this;
		this.events.subscribe(DomainEvents.INTENT_RECEIVED, (intent) => {
			console.info('Ricevuto intent da altra app: ', intent)
			try {
				let uri = self.parseUri(intent.data);
				switch (uri.protocol) {
					case 'callhidden':
						switch (uri.path) {
							case 'called':
								console.log('Ricevuta notifica di fine chiamata', uri);

								let talkTime = parseInt(uri.params.T);

								if (talkTime == 0) {
									let toastUnanswered = self.toastCtrl.create({
										message: 'Utente non disponibile',
										position: 'middle',
										duration: 3000,
										cssClass: "danger"
									});
									toastUnanswered.present();
								} else {
									let toastAnswered = self.toastCtrl.create({
										message: 'Chiamata terminata',
										position: 'middle',
										duration: 3000,
										cssClass: "success"
									});
									toastAnswered.present();
								}

								return;
							case 'callerror':
								console.log('Ricevuta notifica di errore chiamata', uri);
								let toastKo = self.toastCtrl.create({
									message: 'Errore durante la chiamata',
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toastKo.present();
								return;
						}
						break;
				}
				console.warn('Ricevuto intent non riconosciuto', intent)
			} catch (e) {
				console.error("Errore recuperando i dati dall'intent ricevuto", e)
			}
		})
	}

	private parseUri(url: String) {
		var result = {
			protocol: <string>null,
			hostname: null,
			host: null,
			path: '',
			pathname: null,
			port: null,
			search: null,
			hash: null,
			href: null,
			requestUri: null,
			params: null,
		};

		var anchor: any = document.createElement('a');
		anchor.href = url;
		for (var field in result) {
			result[field] = anchor[field];
		}

		//URI
		result.requestUri = result.pathname + result.search;

		/*
		function nthIndex(str, pat, n) {
		var l = str.length, i = -1;
		while (n-- && i++ < l) {
		i = str.indexOf(pat, i);
		if (i < 0) break;
	}
	return i;
}
*/

		if (result.protocol && result.protocol.endsWith(':')) {
			result.protocol = result.protocol.slice(0, result.protocol.length - 1);
		}

		if (result.pathname) {
			if (result.pathname.startsWith('//')) {
				result.pathname = result.pathname.slice(2);
			}
			//let pathindex = nthIndex(result.pathname, '/', 3);
			let pathindex = result.pathname.indexOf('/');
			if (pathindex > 0) {
				result.path = result.pathname.slice(pathindex + 1);
			}
		}
		//parametri
		result.params = {};
		if (result.search) {
			let hashes = result.search.slice(result.search.indexOf('?') + 1).split('&')
			hashes.map(hash => {
				let [key, val] = hash.split('=')
				result.params[key] = decodeURIComponent(val)
			})
		}
		return result;
	}


	/**
	sono codificati nella uri: 'tel:nnn?R=XXXX&T=XXX&RT=XXX&TT=XXX&ST=XXX'

	NON usare i carattere "&" all'interno dei valori per non compromettere la lettura della uri
	nnn Numero da chiamare [obbligatorio]
	R Tempo massimo squillo [opzionale, default 20 secondi]
	T Tempo massimo parlare [opzionale, default 60 secondi]
	RT Testo visualizzato quando squilla [opzionale, default "Sto suonando.."]
	TT Testo visualizzato quando parla [opzionale, default "Connesso.."]
	ST Testo per il pulsante fine chiamata [opzionale, default "Termina"]

	Avvia una chiamata anonima attraverso un'apposita app esterna

	restituisce una promise che risolve in vero se partita correttamente, falso se la funzione non è disponibile (es. browser), reject se ci sono errori
	*/
	public callHidden(number: string, ringTimeout: number = 20, talkTimeout: number = 60, asService: boolean = true): Promise<any> {
		console.debug("[InterappProvider.callHidden()] Inoltro la richiesta di chiamata anonima all'app preposta", arguments)
		if(number==null||number===''){
			return Promise.reject('Numero chiamata diretta non impostato')
		}
		let self = this;

		/*
		private static final String HOST="callhidden.ethicsoft.it";

		Intent intent = new Intent();
		intent.setAction(Intent.ACTION_CALL);
		intent.setData(Uri.parse(SCHEMA+"://"+HOST+"/call?N=%2B393495201864&R=20&T=60&RT=Suonando%20a%20Tizio&TT=Connesso%20a%20Rossi&ST=Fine"));//"vnd.android.cursor.item/it.ethicsoft.callhidden"
		startActivityForResult(intent,REQUEST_CODE);
		*/

		/*
		PARAMETRI:
		callhidden://callhidden.ethicsoft.it/call?N=123456789&R=20&T=20
		N Numero da chiamare [obbligatorio]
		R (ring) Tempo massimo squillo [intero, default 20]
		T (talk) Tempo massimo parlare [intero, default 60]
		-NO- RT (ring text) Testo visualizzato quando squilla [stringa, default "Sto suonando.."]
		-NO- TT (talk text) Testo visualizzato quando parla [stringa, default "Connesso.."]
		-NO- ST (stop text) Testo per il pulsante fine chiamata [stringa, default "Termina"]
		*/
		return new Promise<any>((resolve, reject) => {
			let url = 'callhidden://callhidden.ethicsoft.it/call?N=' + encodeURIComponent(number.trim()) + "&R=" + ringTimeout + "&T=" + talkTimeout;
			if (asService) {
				self.devices.startService(
					'it.ethicsoft.callhidden',
					'it.ethicsoft.callhidden.CallhiddenService',
					url
				).then(result => {
					console.debug("[InterappProvider.callHidden()] Servizio avviato", result);
					resolve(result)
				}).catch(e => {
					console.error("Errore inviando la chiamata", e);
					reject(e)
				});
			} else {
				self.devices.startActivity(url).then(result => {
					console.debug("[InterappProvider.callHidden()] Servizio avviato", result);
					resolve(result)
				}).catch(e => {
					console.error("Errore inviando la chiamata", e);
					reject(e)
				});
			}
		})

		/*
		return new Promise<any>((resolve, reject) => {
		self.devices.askCallPermissions().then(() => {
		let host = "callhidden.ethicsoft.it";
		let schema = "callhidden";
		let url = schema + "://" + host + "/call"
		+ "?N=" + encodeURIComponent(number.trim())
		+ "&R=" + ringTimeout
		+ "&T=" + talkTimeout
		+ "&RT=" + encodeURIComponent(ringText)
		+ "&TT=" + encodeURIComponent(talkText)
		+ "&ST=" + encodeURIComponent(stopText);

		self.devices.startActivityForResult("android.intent.action.CALL", url, (ringTimeout + talkTimeout + 20) * 1000).then(result => {
		//TODO Decodificare result ed usarlo opportunamente, o restituire i valori decodificati
		resolve(result)
	}).catch(e => {
	console.error("Errore avviando l'app per la chiamata nascosta", e);
	reject(e);
	})
	}).catch(e => {
	console.error('Errore richiedendo i permessi per chiamare');
	reject(e);
	})
	})
	*/
	}

	/**
	Avvia l'app per aprire il portone
	*/
	public openDoorway(): Promise<any> {
		console.warn("[InterappProvider.openDoorway()] DEPRECATED: Invio onoff per apertura portone..");

		let self = this;
		return new Promise<any>((resolve, _) => {
			self.devices.startService(
				'it.ethicsoft.btswitch',
				'it.ethicsoft.btswitch.BTSwitchService',
				'btswitch://btswitch.ethicsoft.it/onoff?keep=true'
			).then(result => {
				resolve(result)
			}).catch(e => {
				console.error("Errore richiedendo l'apertura portone", e);
				resolve(false);
			});
		})
	}

	/**
	Avvia l'app per aprire il portone
	*/
	public startBTSwitch(): Promise<any> {
		console.debug("[InterappProvider.startBTSwitch()] Avvio configuratore BTSwitch..");

		let self = this;
		return new Promise<any>((resolve, _) => {
			self.devices.startActivity(
				null,
				null,
				'it.ethicsoft.btswitch',
				'it.ethicsoft.btswitch.MainActivity',
			).then(result => {
				resolve(result)
			}).catch(e => {
				console.error("Errore avviando il configuratore per BTSwitch", e);
				resolve(false);
			});
		})
	}
}



// WEBPACK FOOTER //
// ./src/providers/interapp/interapp.ts